import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PaperDetailContent from './PaperDetailContent';
import { getPaperById, getRelatedPapers, removeUserPaper } from '@/lib/data';

/**
 * Slide-over panel for viewing a paper's details without navigating away
 * from whatever is behind it (e.g. the relationship graph, so zoom/layout
 * state isn't lost).
 */
export default function PaperDetailPanel({ paperId, papers, config, onClose, onSelectPaper, onRemoved }) {
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  const paper = getPaperById(papers, paperId);
  if (!paper) return null;

  const artifactConfig = Object.fromEntries((config.typesOfArtifact || []).map((t) => [t.id, t]));
  const relatedPapers = getRelatedPapers(papers, paper);

  const handleRemove = async () => {
    await removeUserPaper(paper._userKey);
    onClose();
    onRemoved?.();
  };

  return (
    <>
      <div className="paper-panel__backdrop" onClick={onClose} />
      <div className="paper-panel" role="dialog" aria-labelledby="paper-panel-title">
        <div className="paper-panel__header">
          <button className="btn btn--ghost btn--sm" onClick={() => navigate(`/papers/${paper._id}`)}>
            Open full page →
          </button>
          <button className="paper-panel__close" onClick={onClose} aria-label="Close panel">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="paper-panel__content">
          <PaperDetailContent
            paper={paper}
            artifactConfig={artifactConfig}
            relatedPapers={relatedPapers}
            onRelatedClick={onSelectPaper}
            onRemove={paper._userAdded ? handleRemove : undefined}
          />
        </div>
      </div>
    </>
  );
}
